import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import * as stateSelectors from '../../blk-model-subscription-manger.selectors';
import { UserDataHandlerService } from '../../services/store-data-loader.service';
import { UserDataService } from '../../services/user-data.service';
import * as actions from './../subscribed-model-portfolios/subscribed-model-portfolios.actions';

@Injectable()
export class SubscribedModelPortfoliosEffects {
	
	public subscribeModelPortfolio: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType<actions.SubscribeModelApiRequest>(actions.SUBSCRIBE_MODEL_API_REQUEST),
		switchMap(action => {
			console.log(`Subscribing in effect:  ${action.portfolioId}`);
			return this.userDataService.subscribeBlkModelPortfolioToAPI(action.portfolioId, action.origin).pipe(
				map(responseJson => {
					const newMapping: Map<string, string> = this.userDataHandler.getNewMapping(responseJson, action.portfolioId);

					if (newMapping.size) {
						return {
							type: actions.ADD_SUBSCRIPTION_STORE_MAPPING,
							newMapping: newMapping
						} as Action;
					} else {
						return { type: 'FAIL' } as Action;
					}
				})
			);
		}),
		catchError(error => {
			console.error(`[ERROR] Failed to subscribe to model: ${error}`);
			return of({} as Action);
		})
	));

	
	public unsubscribeModelPortfolio: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType<actions.UnsubscribeModelApiRequest>(actions.UNSUBSCRIBE_MODEL_API_REQUEST),
		withLatestFrom(this.store$.pipe(select(stateSelectors.getSubscribedModelPortfolioIdMappings))),
		switchMap(([action, subscriptionMappings]) => {
			const uniqueId: string = subscriptionMappings.get(action.portfolioId);
			console.log(`Unsubscribing in effect, portfolioId:  ${action.portfolioId}, uniqueId: ${uniqueId}`);
			return this.userDataService.unsubscribeBlkModelPortfolioToAPI(uniqueId).pipe(
				map(responseJson => {
					const successful: boolean = this.userDataHandler.isDeleteSuccessful(responseJson);
					if (successful) {
						return {
							type: actions.REMOVE_SUBSCRIPTION_STORE_MAPPING,
							portfolioId: action.portfolioId
						} as Action;
					} else {
						return { type: 'FAIL' } as Action;
					}
				}),
				catchError(error => {
					return of({ type: 'FAIL' } as Action);
				})
			);
		})
	));

	constructor(private actions$: Actions, private userDataService: UserDataService, private userDataHandler: UserDataHandlerService, private store$: Store<any>) { }
}
